"use strict";
export function arrayToSlices(items, size) {
  if (items.length % size !== 0) {
    throw new Error("Input array length must be a multiple of desired output size");
  }
  return Array.from({ length: Math.floor(items.length / size) }, (_v, i) => items.slice(i * size, i * size + size));
}
